import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Create shop", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  className: "control-label",
  htmlFor: "firstname"
}, "Name", -1)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  className: "control-label",
  htmlFor: "firstname"
}, "Address", -1)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  className: "control-label",
  htmlFor: "firstname"
}, "Url", -1)
const _hoisted_11 = { class: "form-group row p-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 p-2 control-label" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Müügikoha pilt")
], -1)
const _hoisted_13 = { class: "col-8 p-2" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  className: "control-label",
  htmlFor: "firstname"
}, "Latitude", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-broadcast" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-broadcast" }, null, -1)
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  className: "control-label",
  htmlFor: "firstname"
}, "Longitude", -1)
const _hoisted_20 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_upload_image = _resolveComponent("upload-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          title: "",
          back: "home"
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errorMsg != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              className: "form-control",
              type: "text",
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchShop && _ctx.searchShop(...args)))
            }, null, 544), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.address) = $event)),
              className: "form-control",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.address]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.url) = $event)),
              className: "form-control",
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.url]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_upload_image)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.latitude) = $event)),
              className: "form-control",
              type: "text",
              style: {"width":"100px"}
            }, null, 512), [
              [_vModelText, _ctx.latitude]
            ]),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickGeolocation && _ctx.clickGeolocation(...args)))
            }, [
              _hoisted_16,
              _createTextVNode(" Minu asukoht")
            ]),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickTallinnLocation && _ctx.clickTallinnLocation(...args)))
            }, [
              _hoisted_17,
              _createTextVNode(" Tallinn")
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.longitude) = $event)),
              className: "form-control",
              type: "text",
              style: {"width":"100px"}
            }, null, 512), [
              [_vModelText, _ctx.longitude]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("input", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitClicked())),
              type: "submit",
              value: "Create",
              class: "btn btn-primary"
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createTextVNode(" Shops with similar name found: " + _toDisplayString(_ctx.getShopList().length) + " ", 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getShopList(), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id
              }, _toDisplayString(item.name), 1))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}